<template>
    <b-card no-body>
        <b-card-header class="title-display">
            <span class="title-one">Applicant Information</span>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col md="12" lg="5" class="info-item">
                    <div class="text-left title-three">
                        <u>Applicant</u>
                    </div>
                    <b-row class="info-text">
                        <b-col cols="12"
                               xmd="6"
                               xsm="12"
                               class="ml-3 title-five"
                        >
                            Name:
                            <div class="title-four d-sm-inline">
                                {{ applicantName }}
                            </div>
                        </b-col>
                        <b-col cols="12"
                               xmd="4"
                               xsm="12"
                               class="ml-3 title-five"
                        >
                            FICE Code (Portal ID):
                            <div class="title-four d-sm-inline">
                                {{ applicantId }}
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <template v-for="(c, key) in coordinators">
                    <b-col :key="key" md="12" lg="7">
                        <div class="text-left title-three">
                            <hr class="dotted-line d-lg-none">
                            <u>Perkins Coordinator</u>&nbsp;
                            <span v-if="!hasCoordinatorInfo">
                                <fa-icon id="coordinator-warning"
                                         :icon="['fas', 'info-circle']"
                                         class="text-warning"
                                />
                                <b-popover target="coordinator-warning"
                                           triggers="hover"
                                           placement="auto"
                                >
                                    <template #title>
                                        Perkins Coordinator
                                    </template>
                                    Please enter the Perkins Coordinator information on the <b>Assurances</b> tab.
                                </b-popover>
                            </span>
                        </div>
                        <b-row class="info-text">
                            <b-col cols="12" class="ml-3 title-five">
                                Name:
                                <span class="title-four">
                                    {{ c.name }}
                                </span>
                            </b-col>

                            <b-col cols="12" class="ml-3 title-five">
                                Phone:
                                <span class="title-four">
                                    {{ c.phone }}
                                </span>
                            </b-col>

                            <b-col cols="12" class="ml-3 title-five">
                                Email:
                                <span class="title-four">
                                    {{ c.email }}
                                </span>
                            </b-col>
                        </b-row>
                    </b-col>
                </template>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'GeneralInformation',

    computed: {
        ...mapGetters({
            generalInformation: 'coverpage/generalInformation',
            hasCoordinatorInfo: 'coverpage/hasCoordinatorInfo'
        }),

        ...mapState('coverpage', {
            assurancesStatementAgreed: (state) => state.data.content.assurancesStatementAgreed,
            coverpageContent: (state) => state.data.content,
        }),

        applicantName() {
            return (this.generalInformation.applicant_name) || 'No Applicant Name';
        },

        applicantId() {
            return this.generalInformation.applicant_id || 'Unknown';
        },

        coordinators() {
            return this.hasCoordinatorInfo
                ? [{
                    name: this.coverpageContent.coordinatorName || '',
                    phone: this.coverpageContent.coordinatorPhone.replace(
                        /(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'
                    ) || '',
                    email: this.coverpageContent.coordinatorEmail || ''
                }] : [{
                    name: '',
                    phone: '',
                    email: ''
                }];
        },
    },
};
</script>

<style>
.title-five {
    font-size: 0.85rem;
}
</style>
